import { selectFromVisitDto } from '../../models';

export default selectFromVisitDto()
  .id
  .name
  .uuid
  .eventUuid
  .isPriority
  .instructions
  .email
  .phone
  .duration
  .isCompleted
  .isScheduled
  .routificOrderNumber
  .pendingTargetRouteUuid
  .attempts(attempt => attempt
    .orderUuid
    .status
    .reason
    .notes
    .date)
  .rating(rating => rating.rate.comment)
  .locations(location => location.id.address.originalAddress.latitude.longitude.active.bestMatch)
  .timeWindows(timeWindow => timeWindow.id.startTime.endTime)
  .toString();
